import React, { useState } from "react";
import {
  Box, Typography, Button, Paper, Alert
} from "@mui/material";
import { Upload, CheckCircle, CloudUpload } from "@mui/icons-material";

export default function PasoSubirXML({ xmlFile, onFileChange, onParsear, loading }) {
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFileChange(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      onFileChange(e.target.files[0]);
    }
  };

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        📄 Paso 1: Subir XML de Factura
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        Seleccione el archivo XML de la factura del proveedor. El sistema parseará automáticamente todos los datos.
      </Alert>

      {/* Zona de carga */}
      <Paper
        sx={{
          p: 4,
          textAlign: "center",
          border: dragActive ? "2px dashed #4CAF50" : "2px dashed #ccc",
          bgcolor: dragActive ? "#f0f8f0" : "#fafafa",
          cursor: "pointer",
          transition: "all 0.3s",
          "&:hover": {
            borderColor: "#4CAF50",
            bgcolor: "#f9f9f9"
          }
        }}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <CloudUpload sx={{ fontSize: 64, color: "#4CAF50", mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          Arrastra el archivo XML aquí
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          o haz clic para seleccionar
        </Typography>
        
        <input
          type="file"
          accept=".xml"
          onChange={handleChange}
          disabled={loading}
          style={{ display: "none" }}
          id="file-input"
        />
        <label htmlFor="file-input">
          <Button
            variant="outlined"
            component="span"
            startIcon={<Upload />}
            disabled={loading}
          >
            Seleccionar Archivo
          </Button>
        </label>
      </Paper>

      {/* Archivo seleccionado */}
      {xmlFile && (
        <Paper sx={{ p: 2, mt: 3, bgcolor: "#e8f5e9", display: "flex", alignItems: "center", gap: 2 }}>
          <CheckCircle color="success" />
          <Box sx={{ flex: 1 }}>
            <Typography variant="body1" fontWeight={600}>
              {xmlFile.name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {(xmlFile.size / 1024).toFixed(2)} KB
            </Typography>
          </Box>
          <Button
            variant="text"
            color="error"
            onClick={() => onFileChange(null)}
            disabled={loading}
          >
            Eliminar
          </Button>
        </Paper>
      )}

      {/* Botón de parsear */}
      <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          size="large"
          onClick={onParsear}
          disabled={!xmlFile || loading}
          startIcon={loading ? null : <CheckCircle />}
        >
          {loading ? "Procesando..." : "Procesar XML"}
        </Button>
      </Box>

      {/* Instrucciones */}
      <Paper sx={{ p: 3, mt: 4, bgcolor: "#f5f5f5" }}>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          📋 Instrucciones:
        </Typography>
        <ol style={{ margin: 0, paddingLeft: 20 }}>
          <li>Seleccione el archivo XML de la factura del proveedor</li>
          <li>El sistema parseará automáticamente:
            <ul>
              <li>Datos del proveedor</li>
              <li>Productos/servicios</li>
              <li>Totales e impuestos</li>
              <li>Retenciones calculadas</li>
            </ul>
          </li>
          <li>Revise la información y confirme la compra en el siguiente paso</li>
        </ol>
      </Paper>
    </Box>
  );
}
